import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './lib/auth';
import { StaffAuthProvider } from './lib/staffAuth';
import ProtectedRoute, { GuestOnly, RequireActivePlan, RequireStaffVerified } from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import SelectOrg from './pages/SelectOrg';
import Onboarding from './pages/Onboarding';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import Terms from './pages/legal/Terms';
import CookiesPolicy from './pages/legal/CookiesPolicy';
import Dashboard from './pages/Dashboard';
import Diagnostic from './pages/Diagnostic';
import DiagnosticPublic from './pages/DiagnosticPublic';
import ActionPlan from './pages/ActionPlan';
import Settings from './pages/Settings';
import News from './pages/News';
import RAT from './pages/RAT';
import Documents from './pages/Documents';
import Audit from './pages/Audit';
import Sistemas from './pages/Sistemas';
import Trazabilidad from './pages/Trazabilidad';
import Arco from './pages/Arco';
import ArcoPublic, { ArcoVerify } from './pages/ArcoPublic';
import Cmp from './pages/Cmp';
import Brechas from './pages/Brechas';
import BrechaDetail from './pages/BrechaDetail';
import Dpia from './pages/Dpia';
import DpiaDetail from './pages/DpiaDetail';
import Fiscalizacion from './pages/Fiscalizacion';
import Team from './pages/Team';
import AcceptInvite from './pages/AcceptInvite';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PriviaxAdmin from './pages/PriviaxAdmin';
import PriviaxLogin from './pages/PriviaxLogin';
import './App.css';

function OnboardingGate({ children }) {
  const { organization } = useAuth();
  if (organization && !organization.onboarding_complete) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StaffAuthProvider>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#fff',
                border: '1px solid #E5E7EB',
                color: '#1C2329',
                fontSize: 13.5,
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/noticias" element={<News />} />
            <Route path="/privacidad" element={<PrivacyPolicy />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/cookies-y-almacenamiento" element={<CookiesPolicy />} />
            <Route path="/derechos/:slug" element={<ArcoPublic />} />
            <Route path="/derechos/verificar/:token" element={<ArcoVerify />} />
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/registro" element={<GuestOnly><Register /></GuestOnly>} />
            <Route
              path="/seleccionar-organizacion"
              element={<ProtectedRoute><SelectOrg /></ProtectedRoute>}
            />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute><Onboarding /></ProtectedRoute>
              }
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <OnboardingGate><AppShell /></OnboardingGate>
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="diagnostico" element={<Diagnostic />} />
              <Route path="plan" element={<RequireActivePlan moduleName="El Plan de Acción"><ActionPlan /></RequireActivePlan>} />
              <Route path="rat" element={<RequireActivePlan moduleName="El módulo RAT"><RAT /></RequireActivePlan>} />
              <Route path="sistemas" element={<RequireActivePlan moduleName="El Catastro de Sistemas"><Sistemas /></RequireActivePlan>} />
              <Route path="documentos" element={<RequireActivePlan moduleName="El módulo Documentos"><Documents /></RequireActivePlan>} />
              <Route path="cookies" element={<RequireActivePlan moduleName="El módulo Cookies (CMP)"><Cmp /></RequireActivePlan>} />
              <Route path="arco" element={<RequireActivePlan moduleName="Las Solicitudes ARCO+"><Arco /></RequireActivePlan>} />
              <Route path="brechas" element={<RequireActivePlan moduleName="El módulo Brechas 72h"><Brechas /></RequireActivePlan>} />
              <Route path="brechas/:id" element={<RequireActivePlan moduleName="El módulo Brechas 72h"><BrechaDetail /></RequireActivePlan>} />
              <Route path="dpia" element={<RequireActivePlan moduleName="El módulo DPIA"><Dpia /></RequireActivePlan>} />
              <Route path="dpia/:id" element={<RequireActivePlan moduleName="El módulo DPIA"><DpiaDetail /></RequireActivePlan>} />
              <Route path="fiscalizacion" element={<RequireActivePlan moduleName="La Carpeta de Fiscalización"><Fiscalizacion /></RequireActivePlan>} />
              <Route path="trazabilidad" element={<RequireActivePlan moduleName="La Trazabilidad"><Trazabilidad /></RequireActivePlan>} />
              <Route path="auditoria" element={<RequireActivePlan moduleName="La Auditoría"><Audit /></RequireActivePlan>} />
              <Route path="equipo" element={<RequireActivePlan moduleName="La gestión de Equipo"><Team /></RequireActivePlan>} />
              <Route path="configuracion" element={<Settings />} />
            </Route>
            <Route path="/diagnostico-gratis" element={<DiagnosticPublic />} />
            <Route path="/priviax-login" element={<PriviaxLogin />} />
            <Route path="/priviax-admin" element={<RequireStaffVerified><PriviaxAdmin /></RequireStaffVerified>} />
            <Route path="/invitacion/:token" element={<AcceptInvite />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
        </StaffAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
